const url = '/categories';
const Provider = 'Categories';
const dbModel = 'Categories';

export { url, Provider, dbModel };
